import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

const acceptTermsThunk = createAsyncThunk(
  'profile/acceptTermsThunk',
  async () => {
    try {
      const apiPointName = 'acceptTerms';

      return await doFetch<typeof apiPointName>({
        apiPointName,
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default acceptTermsThunk;
